import FadeUp from "./FadeUp";
import { ServiceDiagram } from "./ServiceDiagrams";

const services = [
    {
        id: "multi-channel",
        title: "Multi-channel creator partnerships",
        body: "We work across YouTube, newsletters, podcasts, LinkedIn, Instagram, and TikTok to reach relevant audiences and build creator-led acquisition channels.",
    },
    {
        id: "micro-macro",
        title: "Micro + macro creator mix",
        body: "We use micro creators to test messaging, identify winning audiences, and generate content at volume. Macro creators help expand reach, build authority, and strengthen brand credibility.",
    },
    {
        id: "aeo-geo",
        title: "AEO/GEO + creator marketing",
        body: "Third-party content help brands build authority and improve their chances of being discovered across AI-powered search and answer engines.",
    },
    {
        id: "execution",
        title: "360-degree execution",
        body: "We handle the entire process, including creator discovery, outreach, negotiation, activation, tracking, optimization, and reporting. No juggling vendors, no managing creator campaigns yourself.",
    },
];

export const WhatWeDo = () => (
    <section
        id="services"
        data-testid="what-we-do-section"
        className="py-24 md:py-32 bg-white"
    >
        <div className="container-page">
            <div className="max-w-3xl">
                <FadeUp delay={0.05}>
                    <h2
                        data-testid="what-we-do-heading"
                        className="mt-4 font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-[-0.02em] leading-[1.4] md:leading-[1.4] lg:leading-[1.4] text-[#0A0A0A] text-balance"
                    >
                        One creator engine. Multiple acquisition channels.
                    </h2>
                </FadeUp>
                <FadeUp delay={0.1}>
                    <p className="mt-5 text-[15.5px] md:text-base text-gray-600 leading-[1.75] max-w-2xl">
                        Four capabilities that run as one system, from finding the right creators to reporting on the customers they bring in.
                    </p>
                </FadeUp>
            </div>

            <div className="mt-14 grid md:grid-cols-2 gap-4 md:gap-5">
                {services.map((s, i) => (
                    <FadeUp key={s.id} delay={0.05 + (i % 2) * 0.05}>
                        <div
                            data-testid={`what-we-do-card-${s.id}`}
                            className="group h-full rounded-2xl border border-black/[0.08] bg-white p-6 md:p-7 hover:border-black/20 hover:-translate-y-0.5 transition-all flex flex-col"
                        >
                            <div className="flex items-center justify-between">
                                <div className="inline-flex items-center gap-2 rounded-full bg-[#FAFAFA] border border-black/[0.06] px-3 py-1 text-[11px] font-bold tracking-[0.15em] uppercase text-gray-500">
                                    0{i + 1}
                                </div>
                            </div>
                            <div className="mt-5 rounded-xl bg-[#FAFAFA] border border-black/[0.06] p-4 md:p-5">
                                <ServiceDiagram id={s.id} />
                            </div>
                            <h3 className="mt-6 font-display font-bold text-lg md:text-xl tracking-tight text-[#0A0A0A] leading-[1.4]">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-[14.5px] text-gray-600 leading-[1.75]">
                                {s.body}
                            </p>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);

export default WhatWeDo;
